export { default as CoursePlayer } from './CoursePlayer';
